import { device_json } from './Definitions'
import { v4 } from 'uuid';
import { Route, Box, TrippleBox, RBox, BorderBox } from './Elements'

const Inner = () => {
	return (
		<>
			<marker id="circle-red" markerWidth="5" markerHeight="5" refX="4" refY="2.5" orient="auto">
				<circle cx="2.5" cy="2.5" r="1.5" />
			</marker>
			<marker id="circle-blue" markerWidth="5" markerHeight="5" refX="4" refY="2.5" orient="auto">
				<circle cx="2.5" cy="2.5" r="1.5" />
			</marker>
			<marker id="circle-orange" markerWidth="5" markerHeight="5" refX="4" refY="2.5" orient="auto">
				<circle cx="2.5" cy="2.5" r="1.5" />
			</marker>
			<marker id="circle-gray" markerWidth="5" markerHeight="5" refX="4" refY="2.5" orient="auto">
				<circle cx="2.5" cy="2.5" r="1.5" />
			</marker>
			<marker id="circle-green" markerWidth="5" markerHeight="5" refX="4" refY="2.5" orient="auto">
				<circle cx="2.5" cy="2.5" r="1.5" />
			</marker>
			<marker id="circle-purple" markerWidth="5" markerHeight="5" refX="4" refY="2.5" orient="auto">
				<circle cx="2.5" cy="2.5" r="1.5" />
			</marker>
			<marker id="arrow-gray" markerWidth="5" markerHeight="5" refX="4" refY="2.5" orient="auto">
				<path d='M5,4.5 V0.5 L2.5,2.5 Z' />
			</marker>
			<rect className="secondary" x="100" y="0" width="800" height="600" rx="10" />
			<text className="title" x="420" y="50">EM8500</text>
			{
				device_json.map((c) => {
					if (c.type === 'Route') {
						return (<Route key={ v4() } color={c.color} route={c.route} />)
					} else if (c.type === 'Box') {
						return (
							<Box
								key={ v4() }
								x={c.position[0]}
								y={c.position[1]}
								width={c.size[0]}
								height={c.size[1]}
								lines={c.lines}
							/>
						)
					} else if (c.type === 'TrippleBox') {
						return (
							<TrippleBox
								key={ v4() }
								x={c.position[0]}
								y={c.position[1]}
								width={c.size[0]}
								height={c.size[1]}
								lines={c.lines}
							/>
						)
					} else if (c.type === 'RBox') {
						return (
							<RBox
								key={ v4() }
								x={c.position[0]}
								y={c.position[1]}
								width={c.size[0]}
								height={c.size[1]}
								lines={c.lines}
							/>
						)
					} else if (c.type === 'BorderBox') {
						return (
							<BorderBox
								key={ v4() }
								position={c.position}
							/>
						)
					} else if (c.type === 'Circle') {
						return <circle
							key={ v4() }
							cx={c.position[0]}
							cy={c.position[1]}
							r="3"
							fill="none"
							stroke="black"
						/>
					} else if (c.type === 'Text') {
						return <text
							key={ v4() }
							x={c.position[0]}
							y={c.position[1]}
							textAnchor={c.textAnchor}
							className="static">{c.text}</text>
					} else {
						return <></>
					}
				})
			}
		</>
	)
}

export default Inner
